import { UserRoleCode, type UserDTO } from '@/entities/user'

export const isSuperAdmin = (user: UserDTO | null | undefined): boolean => {
	return user?.role?.code === UserRoleCode.SUPERADMIN
}

export const isAdmin = (user: UserDTO | null | undefined): boolean => {
	return user?.role?.code === UserRoleCode.ADMIN
}

export const isOwner = (user: UserDTO | null | undefined): boolean => {
	return user?.role?.code === UserRoleCode.OWNER
}

export const isMember = (user: UserDTO | null | undefined): boolean => {
	return user?.role?.code === UserRoleCode.MEMBER
}

export const canAccessAdminFeatures = (user: UserDTO | null | undefined): boolean => {
	return isSuperAdmin(user) || isAdmin(user)
}

export const hasRole = (
	user: UserDTO | null | undefined,
	roleCode: UserRoleCode
): boolean => {
	return user?.role?.code === roleCode
}

